import { Alert, CircularProgress, IconButton, Snackbar } from "@mui/material";
import { SnackbarCloseReason } from "@mui/material/Snackbar";
import { useEffect, useState } from "react";

// Hooks
import { useToaster } from "../../hooks/useToasterContext/useToasterContext";

// Toaster component
const Toaster: React.FC = () => {
  const [isOpen, setIsOpen] = useState(true);
  const { isShowToaster, message, severity, isPersistent, setShowToaster } =
    useToaster();

  useEffect(() => {
    if (isShowToaster) {
      setIsOpen(true);
    }
  }, [isShowToaster]);

  const handleClose = (
    _event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    // A persistent notification (e.g. an export in progress) must stay
    // visible for the duration of the operation — only an explicit close or
    // a status update (success/error) may end it, never a stray click away.
    if (isPersistent && reason === "clickaway") return;
    setIsOpen(false);
    setShowToaster(false);
  };

  const action = (
    <>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={() => handleClose()}
      >
        <i className="icon-close" />
      </IconButton>
    </>
  );

  if (!isShowToaster) return null;
  return (
    <>
      <Snackbar
        open={isOpen}
        autoHideDuration={isPersistent ? null : 5000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={handleClose}
      >
        <Alert
          severity={severity}
          variant="filled"
          sx={{ width: "100%" }}
          action={action}
          icon={
            isPersistent ? (
              <CircularProgress size={20} color="inherit" />
            ) : undefined
          }
        >
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Toaster;
